import { unreachable } from 'utils/unreachable';
import { ProjectTasksListData, TasksToBeShown } from './types';

interface EmptyTaskSidePaneCheckerParams {
  tasksToBeShown: TasksToBeShown;
  sharedViews: ProjectTasksListData['views'];
  spotlitViews: ProjectTasksListData['spotlitViews'];
}
export const isEmptyTaskSidePane = ({
  tasksToBeShown,
  sharedViews,
  spotlitViews,
}: EmptyTaskSidePaneCheckerParams) => {
  switch (tasksToBeShown) {
    case TasksToBeShown.AllTasks:
      return false;
    case TasksToBeShown.AllSharedViewsInProject:
      return (
        (sharedViews?.length ?? 0) === 0 && (spotlitViews?.length ?? 0) === 0
      );
    case TasksToBeShown.OnlySpotlitSharedViews:
      return (spotlitViews?.length ?? 0) === 0;
    case TasksToBeShown.CustomFilter:
      return true;
    default:
      return unreachable(tasksToBeShown);
  }
};
